const login = {
    "LOGIN_ROW1":"Academia",
    "LOGIN_ROW2":"Națională",
    "LOGIN_ROW3":"de Șah",
    "LOGIN_COPYRIGHT":"Academia de Șah",
    "LOGIN_FORM_WELCOME":"Bine ai venit!",
    "LOGIN_FORM_SELECT_METHOD":"Selctează una din opțiuni pentru a te loga",
    "LOGIN_FORM_PRIMARY_BUTTON_LABEL":"log in",
    "LOGIN_FORM_FACEBOOK_BUTTON_LABEL":"Autentificare prin Facebook",
    "LOGIN_FORM_GOOGLE_BUTTON_LABEL":"Autentificare prin Google",
    "LOGIN_FORM_LOGIN_PLACEHOLDER":"Login",
    "LOGIN_FORM_PASSWORD_PLACEHOLDER":"Password",
    "BTN_SIGNOUT":"Delogare",
    "LOGIN_FORM_REGISTER_BUTTON":"Înregistrează-te",
    "LOGIN_FORM_FORGET_PASSWORD_BUTTON":"Ați uitat parola?",
    "REGISTER_FORM_WELCOME":"Check-in",
    "REGISTER_FORM_FIRST_NAME_PLACEHOLDER":"Prenumele",
    "REGISTER_FORM_LAST_NAME_PLACEHOLDER":"Numele",
    "REGISTER_FORM_LOGIN_PLACEHOLDER":"adresa poștei electronice",
    "REGISTER_FORM_PASSWORD_PLACEHOLDER":"Alege o parolă",
    "REGISTER_FORM_PRIMARY_BUTTON_LABEL":"Crează un profil",
    "REGISTER_FORM_PHONE_PLACEHOLDER":"Numărul telefonului",
    "REGISTER_FORM_FIRST_NAME_LABEL":"Prenumele Dvs",
    "REGISTER_FORM_LAST_NAME_LABEL":"Numele",
    "REGISTER_FORM_EMAIL_LABEL":"adresa poștei electronice",
    "REGISTER_FORM_EMAIL_PLACEHOLDER":"example@sah.com",
    "REGISTER_FORM_PASSWORD_LABEL":"Parola",
    "REGISTER_FORM_BIRTHDAY_LABEL":"Data nașterii",
    "REGISTER_FORM_PHONE_LABEL":"Numărul telefonului de contact",
    "POPUP_FAIL_HEADER":"Не удалось аутентифицироваться",
    "LBL_BTN_REGISTER":"Înregistrare",
};
export default login